module.exports = __webpack_public_path__ + "img/lg_ring_g_e_null_null@2x.875e3b33.png";